import { useEffect, useState } from "react";

import {
	EVENTO_MOTIVOS,
	carregarMotivosDeEncerramento,
	limparCacheDeMotivos,
	todosOsMotivos,
	MOTIVOS_AUTOMATICOS,
} from "../../helpers/motivosDeEncerramento";

// Os motivos de encerramento desta empresa.
//
// `cadastrados` é o que a equipe pode escolher (a lista do administrador);
// `todos` inclui os automáticos, que ninguém escolhe mas aparecem no selo e no
// filtro. A requisição é uma só por sessão — o hook só espera por ela.
const useMotivosDeEncerramento = () => {
	const [todos, setTodos] = useState(() => todosOsMotivos());

	useEffect(() => {
		let vivo = true;

		const carregar = () =>
			carregarMotivosDeEncerramento().then(() => {
				if (vivo) setTodos(todosOsMotivos());
			});

		carregar();

		// Alguém cadastrou ou desativou um motivo em Configurações: a tela de
		// encerramento tem de refletir isso sem F5.
		const aoMudar = () => {
			limparCacheDeMotivos();
			carregar();
		};

		window.addEventListener(EVENTO_MOTIVOS, aoMudar);

		return () => {
			vivo = false;
			window.removeEventListener(EVENTO_MOTIVOS, aoMudar);
		};
	}, []);

	const automaticos = MOTIVOS_AUTOMATICOS.map((m) => m.chave);

	return {
		todos,
		cadastrados: todos.filter((m) => !automaticos.includes(m.chave)),
	};
};

export default useMotivosDeEncerramento;
